import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sendInvite, getInvites, updateInvite } from '../../../reducers/invites';
import { RoleDefinitions } from '../../../utilities/roles';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Modal from './../../modal';
import AddButton from '../addButton';
import { InviteForm } from '../../forms';
import { getAdmins } from '../../../reducers/users';
import { Snackbar } from '../../snackbar';
import { getFullName } from '../../../utilities/string';

class InviteWitnessButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: { open: false },
            invite: undefined
        };

        this.onInviteSubmitted = this.onInviteSubmitted.bind(this);

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onInviteSubmitted(invite) {
        const { role, getInvites, onSuccess } = this.props;

        Snackbar.success(<FormattedMessage {...messages.inviteSuccess} values={{ name: getFullName(invite) }} />);
        getInvites(role, this.onClose);
        onSuccess();
    }

    onOpen() {
        this.setState({ ...this.state, modal: { open: true } });
    }

    onClose() {
        this.setState({ ...this.state, modal: { open: false }, invite: undefined });
    }

    // componentDidMount() {

    // }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { modal } = this.state;
        const { update } = nextProps;
        if (!update) {
            return;
        }

        const { invite, onPassed } = update;

        if (!modal.open && invite && onPassed) {
            this.setState({ modal: { open: true }, invite: { ...invite } }, onPassed);
        }
    }

    render() {
        const { modal, invite } = this.state;
        const { button, sendInvite, updateInvite, i9, details } = this.props;

        const availableRoles = [RoleDefinitions.Witness];

        // TODO - make this a regular rectangular button
        const buttonComponent = button ? button(this.onOpen) : <AddButton onClick={this.onOpen} />;
        const inviteeRole = { type: 'i9', id: i9 && i9.id };

        let submitAction = values => sendInvite({ ...values }, inviteeRole, () => this.onInviteSubmitted(values));
        if (invite) {
            submitAction = values => updateInvite(values, inviteeRole, () => this.onInviteSubmitted(values));
        }

        let initialValues = invite ? invite : { ref_id: details.id, ref_type: 'contractor', company_name: undefined };
        let title;
        if (invite === undefined) {
            title = messages.inviteWitness;
        } else {
            title = messages.updateUserInvite;
        }
        return (
            <div>
                {buttonComponent}
                <Modal open={modal.open} onClose={this.onClose} managedClose size="col-sm-8 col-sm-offset-2 col-xs-12" title={<FormattedMessage {...title} />}>
                    <div className="row">
                        <InviteForm
                            onSubmit={submitAction}
                            cancel={this.onClose}
                            tenantType={inviteeRole.type}
                            initialValues={initialValues}
                            availableRoles={availableRoles}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

InviteWitnessButton.defaultProps = {
    button: undefined,
    client: undefined,
    onSuccess: () => {}
};
InviteWitnessButton.propTypes = {
    button: PropTypes.any,
    client: PropTypes.object,
    onSuccess: PropTypes.func
};

const mapStateToProps = state => {
    return {
        role: state.identity.role,
        details: state.identity.details,
        availableAdminHrs: state.users.admins,
        i9: state.i9s.i9
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmins: getAdmins,
            getInvites: getInvites,
            updateInvite: updateInvite,
            sendInvite: sendInvite
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InviteWitnessButton);



// WEBPACK FOOTER //
// ./src/components/richButtons/inviteWitnessButton/index.jsx